export default __webpack_public_path__ + "static/media/arrow-search.eff8ae42.svg";